import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const CRISP_WEBSITE_ID = process.env.REACT_APP_CRISP_WEBSITE_ID;

// Injects the Crisp live-chat widget and identifies the logged-in user.
// Renders nothing — set REACT_APP_CRISP_WEBSITE_ID in the environment to enable.
// Sign up at https://crisp.chat (free tier: 2 agents, unlimited conversations).
const CrispWidget = () => {
    const me = useSelector((state) => state.user.me.value);

    // Bootstrap the Crisp SDK once at mount.
    useEffect(() => {
        if (!CRISP_WEBSITE_ID) return;

        window.$crisp = [];
        window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;

        // Dim the launcher until hovered; stay fully opaque while the chat is open
        // (toggled via the `crisp-open` class on <html>, driven by Crisp events below).
        const style = document.createElement('style');
        style.setAttribute('data-crisp-opacity', '');
        style.textContent = `
            #crisp-chatbox {
                opacity: 0.6;
                transition: opacity 0.2s ease-in-out;
            }
            #crisp-chatbox:hover,
            #crisp-chatbox:focus-within,
            html.crisp-open #crisp-chatbox {
                opacity: 1;
            }
        `;
        document.head.appendChild(style);

        // Keep the widget opaque while a conversation is open.
        window.$crisp.push(['on', 'chat:opened', () => {
            document.documentElement.classList.add('crisp-open');
        }]);
        window.$crisp.push(['on', 'chat:closed', () => {
            document.documentElement.classList.remove('crisp-open');
        }]);

        const script = document.createElement('script');
        script.src = 'https://client.crisp.chat/l.js';
        script.async = true;
        document.head.appendChild(script);
    }, []);

    // Push user identity whenever the logged-in user changes.
    useEffect(() => {
        if (!CRISP_WEBSITE_ID || !window.$crisp || me?.isFalseUser) return;

        if (me?.email) {
            window.$crisp.push(['set', 'user:email', [me.email]]);
        }
        if (me?.name && me.name !== 'Guest') {
            window.$crisp.push(['set', 'user:nickname', [me.name]]);
        }
    }, [me]);

    return null;
};

export default CrispWidget;
